import _ from 'lodash';

import {
  FEE_RECOMMENDATION_AMOUNT_FIELDS,
  FEE_RECOMMENDATION_SESSION_STATUS_DISPLAY,
  FeeRecommendationChangeType,
  FeeRecommendationItemStatus,
  NO_AMOUNT_LABEL,
  SUPERSEDED_SESSION_DISPLAY,
  UNKNOWN_FEE_LABEL,
} from 'constants/feeRecommendations';
import { LESectionCDType, LESectionName } from 'constants/loanApplication';
import { formatCurrencyValue } from 'utils/format';

const ZERO_AMOUNT = 0;

// The backend applies a null recommended bucket as 0 on accept, so null and 0 are the same amount.
const toAmount = value => value ?? ZERO_AMOUNT;

const getAddedBuckets = item =>
  FEE_RECOMMENDATION_AMOUNT_FIELDS.reduce((buckets, { label, proposedKey }) => {
    const proposed = toAmount(item[proposedKey]);

    if (proposed !== ZERO_AMOUNT) {
      buckets.push({ label, original: NO_AMOUNT_LABEL, proposed: formatCurrencyValue(proposed) });
    }

    return buckets;
  }, []);

const getEditedBuckets = item =>
  FEE_RECOMMENDATION_AMOUNT_FIELDS.reduce((changes, { label, proposedKey, originalKey }) => {
    const proposed = toAmount(item[proposedKey]);
    const original = toAmount(item[originalKey]);

    if (proposed !== original) {
      changes.push({
        label,
        original: formatCurrencyValue(original),
        proposed: formatCurrencyValue(proposed),
      });
    }

    return changes;
  }, []);

export const getChangedBuckets = item =>
  item.changeType === FeeRecommendationChangeType.ADD
    ? getAddedBuckets(item)
    : getEditedBuckets(item);

export const getLeSectionLabel = section =>
  LESectionName[section]
    ? `${LESectionCDType[section]}. ${LESectionName[section]}`
    : (section ?? '');

export const getFeeRecommendationHeading = ({ feeTypeName, feeSection }) => {
  const sectionLabel = getLeSectionLabel(feeSection);

  return {
    title: feeTypeName || sectionLabel || UNKNOWN_FEE_LABEL,
    subtitle: feeTypeName && sectionLabel ? sectionLabel : '',
  };
};

export const getSessionStatusDisplay = session => {
  const isFullyReplaced =
    !_.isEmpty(session.items) &&
    session.items.every(item => item.status === FeeRecommendationItemStatus.SUPERSEDED);

  return isFullyReplaced
    ? SUPERSEDED_SESSION_DISPLAY
    : FEE_RECOMMENDATION_SESSION_STATUS_DISPLAY[session.status];
};
